import type { HtmlHTMLAttributes } from 'react'
import React from 'react'
import { csx } from '@vtex/admin-ui'

export type AddToCartSectionRootProps = HtmlHTMLAttributes<HTMLDivElement>

export const AddToCartSectionRoot = ({
  children,
  ...props
}: AddToCartSectionRootProps) => {
  return (
    <div
      className={csx({
        display: 'grid',
        gap: '$space-3',
        gridTemplateRows: '1fr',
        '@tablet': {
          gridTemplateColumns: '152px 1fr',
        },
      })}
      {...props}
    >
      {children}
    </div>
  )
}
